var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"overflow-count"},[_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v(" mdi-star-outline ")]),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }